(function() {
    'use strict';

    angular
        .module('app.impuestosRenta')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/impuestos-renta',
                config: {
                    templateUrl: 'app/impuestosRenta/impuestosRenta.html',
                    controller: 'ImpuestosRenta',
                    controllerAs: 'vm',
                    title: 'ImpuestosRenta'
                }
            },
            {
                url: '/editar-impuesto-renta/:id?',
                config: {
                    templateUrl: 'app/impuestosRenta/editarImpuestoRenta.html',
                    controller: 'EditarImpuestoRenta',
                    controllerAs: 'vm',
                    title: 'EditarImpuestoRenta'
                }
            }
        ];
    }
})();
